import { connect } from 'react-redux';

import { selectSelectedTab } from './Ratings.selectors';
import { updateSelectedTab } from './Ratings.saga';
import Ratings from './Ratings';

const mapStateToProps = state => ({ selectedTab: selectSelectedTab(state) });

const mapDispatchToProps = { updateSelectedTab };

export default connect(mapStateToProps, mapDispatchToProps)(Ratings);
